import React from "react";
import { Menu, MenuItem, Divider } from "@mui/material";
import SelectedMenu from "../../Modules/Dashboard/Unavailability/SelectedMenu";

export interface ActionMenuItem {
    id: string;
    label: string;
    icon: React.ReactNode;
    onClick: () => void;
    danger?: boolean;
    disabled?: boolean;
    dividerBefore?: boolean;
}

export interface ActionsMenuProps {
    open: boolean;
    onClose: () => void;
    menuPos: { top: number; left: number } | null;
    items: ActionMenuItem[];
    minWidth?: number;
}

export default function ActionsMenu({
    open,
    onClose,
    menuPos,
    items,
    minWidth = 220,
}: ActionsMenuProps) {
    return (
        <Menu
            open={open && Boolean(menuPos)}
            onClose={onClose}
            anchorReference="anchorPosition"
            anchorPosition={menuPos ? { top: menuPos.top, left: menuPos.left } : undefined}
            PaperProps={{
                sx: {
                    borderRadius: 1,
                    minWidth: minWidth,
                    boxShadow: "0px 6px 18px rgba(0,0,0,0.12)",
                    overflow: "hidden",
                    mt: 1,
                },
            }}
        >
            {items.map((item, index) => (
                <React.Fragment key={item.id}>
                    {item.dividerBefore && index > 0 && <Divider />}
                    <MenuItem
                        onClick={() => {
                            onClose();
                            item.onClick();
                        }}
                        disabled={item.disabled}
                        sx={{ py: 1.25 }}
                    >
                        <SelectedMenu 
                            label={item.label} 
                            icon={item.icon}
                            danger={item.danger}
                        />
                    </MenuItem>
                </React.Fragment>
            ))}
        </Menu>
    );
}
